import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { getFromStorage } from '../../utils/storage'
import { DOMAIN } from '../../utils/api'
import { currentUserActions } from '../../redux/store'
import { mainBlue, mainGreen, mainRed } from '../../utils/color'

export default function BillList() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const { storeId } = useParams()
	const [billList, setBillList] = useState([])

	const getBillList = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/stock/bill-list/${storeId}`,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setBillList(response.data)
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token, storeId],
	)

	useEffect(() => {
		getBillList()
	}, [getBillList])

	return (
		<UserLayout>
			<Box sx={{ marginX: 'auto', maxWidth: 600, background: '#fff', p: 1 }}>
				<Typography
					sx={{
						fontWeight: 'bold',
						textAlign: 'center',
						letterSpacing: '2px',
						mb: 2,
					}}>
					HÓA ĐƠN {billList[0]?.request?.store?.name}
				</Typography>
				<Table sx={{ mt: 2 }}>
					<TableHead>
						<TableRow>
							<TableCell sx={{ px: 0, py: 1, borderRight: '1px solid #000' }}>STT</TableCell>
							<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>Mã hóa đơn</TableCell>
							<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>Ngày xuất</TableCell>
							<TableCell sx={{ px: 0, py: 1, borderRight: '1px solid #000' }}>Trạng thái</TableCell>
							<TableCell sx={{ px: 0, py: 1 }}>Quản lý</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{billList?.map((item, index) => {
							return (
								<TableRow key={index}>
									<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>{index + 1}</TableCell>
									<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>{item?.billCode}</TableCell>
									<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>{item?.billTimeStamp?.slice(0, 8)}</TableCell>
									<TableCell sx={{ px: 0, py: 1, borderRight: '1px solid #000' }}>
										{item?.payment === 'billed' && (
											<Typography sx={{ color: mainBlue, fontSize: '14px' }}>Chờ XN</Typography>
										)}
										{item?.payment === 'paid' && (
											<Typography sx={{ color: mainGreen, fontSize: '14px' }}>Đã TT</Typography>
										)}
									</TableCell>
									<TableCell sx={{ px: 0, py: 1 }}>
										<Button
											size='small'
											sx={{ color: mainRed, fontSize: '11px', p: 0 }}
											onClick={() => {
												navigate(`/admin/bill-detail/${item.billCode}`)
											}}>
											Chi tiết
										</Button>
									</TableCell>
								</TableRow>
							)
						})}
					</TableBody>
				</Table>
			</Box>
		</UserLayout>
	)
}
